{
    "ControlsAgentButtonTitle": "Mostra tutti i controlli disponibili per l'agente",
    "ControlsDeviceButtonTitle": "Mostra tutti i controlli disponibili per il dispositivo",
    "NAME": "StaticAgentControls"
}